import { Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { IObjectKey } from '@nova/common-interfaces';
import { FUNCTION_NAME, IConduit } from '@rfm/shared-interfaces';
import { CommonService } from '../../../../lib/services/index.mjs';

@Injectable({
  providedIn: 'root',
})
export class ConduitService extends CommonService<IConduit, IObjectKey> {
  public override deleteFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_CONDUIT_REMOVE;
  public override insertFunctionName: FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_CONDUIT_INSERT;
  public override mergeFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_CONDUIT_MERGE;
  public override updateFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_CONDUIT_UPDATE;
  public override getAllFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_CONDUIT_GETALL;
  public override getFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_CONDUIT_GET;
  public override getKeysFunctionName:  FUNCTION_NAME = FUNCTION_NAME.FIBERMANAGEMENT_CONDUIT_GETKEYS;

  constructor(functions: Functions) {
    super(functions);
  }
}
